import { TextFormBlock } from 'models/common/form/formContentBlock/TextFormBlock';

export default class TextFormBlockService {
	toModel(formBlock) {
		return new TextFormBlock(formBlock);
	}
}
